import styled from 'styled-components';

const List = styled.div`
    margin-top: 10px;
`;

export default List;
